// Convert JSON to CSV manually
export function jsonToCsv(jsonData: any[]) {
  let csv = '';
  if (jsonData.length > 0) {
    // Extract headers
    const headers = Object.keys(jsonData[0]);
    csv += headers.join(';') + '\n';

    // Extract values
    jsonData.forEach((obj) => {
      const values = Object.values(obj);
      csv += values.join(';') + '\n';
    });
  }
  return csv;
}
